import styled from '@emotion/styled'
import React, { useEffect, useState } from 'react'
import SimulationGateway from '../../gateways/SimulationGateway'

export const Footer = () => {
  const [importDate, setImportDate] = useState(null)

  useEffect(() => {
    const fetchImportDate = async () => {
      const simulationGateway = new SimulationGateway
      const { importDate } = await simulationGateway.fetchCcamCodeUpdateImportDate()

      setImportDate(importDate)
    }

    fetchImportDate().catch(console.error)
  }, [])

  return (
    <HelpContainer>
      <HelpList>
        <li>
          Pour vous mettre à disposition ce simulateur universel, mySofie
          utilise le jeu de données CCAM, produit par l’Assurance Maladie et
          disponible en opendata&nbsp;
          <a
            href="https://www.ameli.fr/accueil-de-la-ccam/telechargement/index.php"
            target='_blank'
            rel='noreferrer'
          >
          (https://www.ameli.fr/accueil-de-la-ccam/telechargement/index.php).
          </a>&nbsp;
          {!!importDate && `Dernière mise à jour : ${importDate}`}
        </li>
        <li>
          Les montants indiqués dans le simulateur universel mySofie sont
          indicatifs et ne constituent en aucun cas un engagement de
          remboursement de la part de mySofie ou de votre mutuelle. Pour avoir
          une information plus précise, adressez à votre mutuelle le devis
          fourni par le professionnel de santé.
        </li>
      </HelpList>
    </HelpContainer>
  )
}

const HelpContainer = styled.div`
  padding: 30px 20px 50px 5px;
`

const HelpList = styled.ol`
  margin-left: 0;
  padding-left: 20px;
  margin-top: 40px;
  font-size: 0.75rem;
  line-height: 0.85rem;

  li + li {
    margin-top: 20px;
  }
`
